"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendPostMessage = void 0;
const sendPostMessage = (message, parentDomain) => {
  window.parent.postMessage(message, parentDomain);
};
exports.sendPostMessage = sendPostMessage;
//# sourceMappingURL=sender.js.map